import Lang from 'lang.js';
import messages from '../../../../public/messages';

// System language is set in AppMixins
const Translation = new Lang({
    messages: messages,
    locale: 'en',
    fallback: 'en'
});

export default Translation;



// WEBPACK FOOTER //
// ./src/services/Translation.js